// AWS Cognito Configuration
const stage = process.env.REACT_APP_STAGE || 'dev';

// Configuration based on environment
const config = {
  dev: {
    userPoolId: process.env.REACT_APP_COGNITO_USER_POOL_ID || 'us-east-1_xb2ktb5j6',
    userPoolWebClientId: process.env.REACT_APP_COGNITO_CLIENT_ID || '1vg12shffn2praec1c2s01tvii',
    region: process.env.REACT_APP_COGNITO_REGION || 'us-east-1',
    hostedUI: process.env.REACT_APP_COGNITO_DOMAIN || null,
    redirectSignIn: process.env.REACT_APP_REDIRECT_SIGN_IN || 'https://login-dev.team-skynet.io/callback',
    redirectSignOut: process.env.REACT_APP_REDIRECT_SIGN_OUT || 'https://login-dev.team-skynet.io/'
  },
  prod: {
    userPoolId: process.env.REACT_APP_COGNITO_USER_POOL_ID || 'us-east-1_DAhdvep62',
    userPoolWebClientId: process.env.REACT_APP_COGNITO_CLIENT_ID || '1vg12shffn2praec1c2s01tvii',
    region: process.env.REACT_APP_COGNITO_REGION || 'us-east-1',
    hostedUI: process.env.REACT_APP_COGNITO_DOMAIN || null,
    redirectSignIn: process.env.REACT_APP_REDIRECT_SIGN_IN || 'https://login.team-skynet.io/callback',
    redirectSignOut: process.env.REACT_APP_REDIRECT_SIGN_OUT || 'https://login.team-skynet.io/'
  }
};

export default config[stage];
